export default function initQuickHelp() {
    const container = document.querySelector("#quickHelp");
    if (!container) return; // No Quick Help on this page

    const toggle = container.querySelector(".quickhelp__toggle");
    const overlay = container.querySelector(".quickhelp__overlay");
    const closeBtn = container.querySelector(".quickhelp__close");

    // If any required element is missing, exit safely
    if (!toggle || !overlay || !closeBtn) return;

    const open = () => container.classList.add("quickhelp--open");
    const close = () => container.classList.remove("quickhelp--open");

    toggle.addEventListener("click", open);
    overlay.addEventListener("click", close);
    closeBtn.addEventListener("click", close);
}